import { VideoPlatform } from "../types";
import { QualityMode } from "./room/participant/media/types";
import { AudioVideoSettings, BackgroundType } from "./types";

export const DEFAULT_LOCAL_CONTEXT_VALUE = {};

export const QUALITY_MODE_NUMBER_MAP = {
  [QualityMode.High]: 3,
  [QualityMode.Medium]: 2,
  [QualityMode.Low]: 1,
};

const DEFAULT_BACKGROUND_SETTINGS = {
  backgroundType: BackgroundType.NONE,
};

export const DEFAULT_VIDEO_SETTINGS: AudioVideoSettings = {
  isAudioEnabled: true,
  isVideoEnabled: true,
  videoIsMirrored: true,
  videoQualityMode: QualityMode.High,
  selfViewIsHidden: false,
  noiseCancellationIsEnabled: true,
  ...DEFAULT_BACKGROUND_SETTINGS,
};

export const STORED_AUDIO_VIDEO_SETTINGS_KEY = "audio-video-settings";

export const VIDEO_PLATFORMS = new Set<VideoPlatform>(
  Object.values(VideoPlatform),
);
